import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJob, deleteJob, editJob, getJobs, getSingleJobData } from "./jobApi";

const initialState = {
  isLoading: false,
  isError: false,
  jobs: [],
  error: "",
  editing: {}
};

export const fetchJobs = createAsyncThunk("job/fetchJobs", async () => {
  const jobs = await getJobs();

  return jobs;
});

export const createJob = createAsyncThunk("job/createJob", async (data) => {
  const job = await addJob(data);

  return job;
});

export const updateJob = createAsyncThunk(
  "job/updateJob",
  async ({ data, id }) => {
    const job = await editJob(data, id);

    return job;
  }
);

export const removeJob = createAsyncThunk("job/removeJob", async (id) => {
  const job = await deleteJob(id);

  return job;
});

export const fetchSingleJob = createAsyncThunk("job/fetchSingleJob", async(id) => {
    const job = getSingleJobData(id);

    return job
})

const jobSlice = createSlice({
  name: "job",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
        state.jobs = [];
      })
      .addCase(createJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = [...state.jobs, action.payload];
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(updateJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(updateJob.fulfilled, (state, action) => {
        state.isLoading = false;
        const indexToUpdate = state.jobs.findIndex((job) => job.id === action.payload.id);
        console.log(indexToUpdate);
        state.jobs[indexToUpdate] = action.payload;
      })
      .addCase(updateJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(removeJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = state.jobs.filter((job) => job.id !== action.meta.arg);
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      .addCase(fetchSingleJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(fetchSingleJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.editing = action.payload;
      })
      .addCase(fetchSingleJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      });
  },
});

export default jobSlice.reducer;
